module.exports = __webpack_public_path__ + "img/SES_220411120.f6a32421.jpg";